(function () {
  const initSlider = (section) => {
    if (!section) return;
    const slider = section.querySelector('.quote-testimonial__swiper');
    if (!slider) return;
    if (typeof Swiper === 'undefined') return;

    const columns = Number(slider.dataset.columns) || 3;
    const columnsConfig = {
      4: {
        576: { slidesPerView: 2, spaceBetween: 16 },
        750: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 24 },
      },
      3: {
        576: { slidesPerView: 2, spaceBetween: 16 },
        990: { slidesPerView: 3, spaceBetween: 24 },
      },
      2: {
        576: { slidesPerView: 2, spaceBetween: 20 },
      },
      1: {
        576: { slidesPerView: 1 },
      },
    };

    const prevBtn = section.querySelector('.cards-grid__navigation-button-prev');
    const nextBtn = section.querySelector('.cards-grid__navigation-button-next');
    const pagination = section.querySelector('.quote-testimonial__pagination');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      speed: 700,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial',
        paginationBulletMessage: 'Go to testimonial {{index}}',
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'swiper-button-disabled',
      },
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
            bulletElement: 'button',
          }
        : false,
      breakpoints: columnsConfig[columns],
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initSlider(event.target);
  });
})();
